import { makeObservable, observable, action } from 'mobx';

export type RequestType = 'reservation' | 'reimbursement';

class RequestTypeDialogStore {
  isOpen: boolean = false;
  // Voľba z modálu — 'reimbursement' = "Zariadenie už mám nainštalované"
  requestType: RequestType = 'reservation';

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      requestType: observable,
      open: action,
      close: action,
      setRequestType: action
    });
  }

  open = () => {
    this.isOpen = true;
  };

  close = () => {
    this.isOpen = false;
  };

  setRequestType = (value: RequestType) => {
    this.requestType = value;
  };
}

const singleton = new RequestTypeDialogStore();
export default singleton;
